export default __webpack_public_path__ + "static/media/houseimage1.f5e4a8e8.png";